module.exports = __webpack_public_path__ + "static/media/hallie.0908571c.png";